// <div data-controller="darkmode">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "" ];
  static classes = [ "" ]
  static values = {};

  initialize() {

  }

  addDebugger = () => {
    const html = document.documentElement;
    const toggler = document.createElement("a")
    toggler.innerText = "🌗"
    toggler.style.fontSize = "30px";
    toggler.style.position = "absolute";
    toggler.style.bottom = "20px";
    toggler.style.right = "20px";
    toggler.addEventListener("click", () => {
      if (html.classList.contains("light-theme")) {
        html.classList.remove('light-theme');
        html.classList.add('dark-theme', "dark");
      } else {
        html.classList.remove('dark-theme', 'dark');
        html.classList.add('light-theme');
      }
    })
    document.body.append(toggler);
  }

  connect() {
    if (process.env.NODE_ENV !== "production") {
      this.addDebugger();
    }
  }

  disconnect() {

  }
}